import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtTextField, TtBadge } from '@23/ui-react'

import {
  removeMix,
  saveEditingMix,
  setEditingMix,
  updateEditingMixName,
  useEditingMixState,
} from '../../firebase/hooks/useMixes'

import './MixEditingToolbar.scss'

const MixEditingToolbar = () => {
  const editingMix = useEditingMixState()

  if (!editingMix) return null

  return (
    <>
      <div className="mix-editing-toolbar">
        <TtTextField
          label={intl.formatMessage({ defaultMessage: 'Mix Name' })}
          hideLabel
          placeholder={intl.formatMessage({ defaultMessage: 'Mix Name' })}
          size="small"
          value={editingMix.name}
          onTtInput={(event) => {
            updateEditingMixName(event.detail.value)
          }}
        />
        <TtButton
          size="small"
          color="secondary"
          variant="ghost"
          onClick={() => {
            void removeMix(editingMix.id)
            setEditingMix(null)
          }}
        >
          <FormattedMessage defaultMessage="Delete" />
        </TtButton>
        <TtButton
          color="secondary"
          size="small"
          onClick={async () => {
            await saveEditingMix()
            setEditingMix(null)
          }}
        >
          <FormattedMessage defaultMessage="Save" />
        </TtButton>
      </div>
      <TtBadge className="mix-editing-badge" color="yellow">
        <FormattedMessage defaultMessage="Editing" />
      </TtBadge>
    </>
  )
}

export { MixEditingToolbar }
